import { render, staticRenderFns } from "./servicePackage.vue?vue&type=template&id=2455a7d7&"
import script from "@/scripts/gpuHub/others/servicePackage.js?vue&type=script&lang=js&"
export * from "@/scripts/gpuHub/others/servicePackage.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports